import { render, staticRenderFns } from "./DepartmentsGrid.vue?vue&type=template&id=1ee1801c"
import script from "./DepartmentsGrid.vue?vue&type=script&lang=js"
export * from "./DepartmentsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports